module.exports = "/_next/static/images/495e7a7c93e0cad8f601e702eef9a269-arrow.svg";